import React, { useState } from 'react'
import './navbar.css'
import { Link, NavLink} from 'react-router-dom'
import logo from "../../images/logo.png";
import {links} from "../../data";
import { FaBarsStaggered } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";

function Navbar() {

    const [isNavShow, setisNavShow] = useState(false)
  return (
    <nav>
        <div className='container nav__container'>
            <Link to="/" className='logo' onClick={()=> setisNavShow(false)}>
                <img src={logo} alt='logo' />
            </Link>

            <ul className={`nav__links ${isNavShow ? 'show__nav' : 'hide__nave'}`}>

                {
                    links.map(({name, path}, index) => {
                        return(
                            <li key={index}>
                                <NavLink to={path} className={({isActive}) => isActive ? 'active-nav' : ''}  
                                    onClick={()=> setisNavShow(prev => !prev)}
                                >{name}</NavLink>
                            </li>
                        )
                    })  
                }

            </ul>
            <button className='nav__toggle-btn' onClick={()=> setisNavShow(prev => !prev)}>
                {
                    isNavShow ? <IoMdClose />: <FaBarsStaggered />
                }
            </button>
        </div>
    </nav>
  )
}

export default Navbar